export default __webpack_public_path__ + "static/media/webtask.71dff9c4.svg";